import { Link } from "react-router-dom";
import { T } from "@/content/ContentContext";

export default function SiteFooter() {
  return (
    <footer data-testid="site-footer" className="bg-brand-night text-brand-bone/70 texture-grain">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div>
            <img src="/mayfair-logo.webp" alt="Mayfair Medical Services" className="h-16 w-auto object-contain rounded-sm" />
            <p className="text-xs uppercase tracking-[0.3em] text-brand-gold mt-4">Licensing · Recruitment · Consultancy</p>
          </div>
          <p className="mt-6 max-w-sm text-sm leading-relaxed font-light">
            <T k="footer.blurb" />
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="overline-label text-brand-gold mb-6">Services</p>
          <ul className="space-y-3 text-sm">
            <li><Link data-testid="footer-link-licensing" to="/licensing" className="hover:text-brand-gold transition-colors duration-300">Medical Licensing</Link></li>
            <li><Link data-testid="footer-link-recruitment" to="/recruitment" className="hover:text-brand-gold transition-colors duration-300">Healthcare Recruitment</Link></li>
            <li><Link data-testid="footer-link-consulting" to="/consulting" className="hover:text-brand-gold transition-colors duration-300">Clinic Consulting</Link></li>
            <li><Link data-testid="footer-link-interim" to="/consulting" className="hover:text-brand-gold transition-colors duration-300">Interim Management</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="overline-label text-brand-gold mb-6">Company</p>
          <ul className="space-y-3 text-sm">
            <li><Link data-testid="footer-link-about" to="/about" className="hover:text-brand-gold transition-colors duration-300">About</Link></li>
            <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-brand-gold transition-colors duration-300">Contact & Enquiries</Link></li>
            <li><Link data-testid="footer-link-admin" to="/admin/login" className="hover:text-brand-gold transition-colors duration-300">Admin Login</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-brand-bone/10">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs tracking-wide text-brand-bone/40">
          <span>© {new Date().getFullYear()} Mayfair Medical Services. All rights reserved.</span>
          <span data-testid="footer-license" className="sm:text-center"><T k="footer.license" /></span>
          <span>United Arab Emirates</span>
        </div>
      </div>
    </footer>
  );
}
